import React, { useEffect, useState } from "react";
import { CHARACTER_RELATE_CONTAIN } from "../CharacterRelateContainNav.const";
import {
  DivNavType,
  RelateContainTypeNav,
} from "../style/CharacterRelateContainNav.style";
import {
  CharacterLetter,
  CharacterResult,
} from "common/character/dto/CharacterResult";

type WordExpressionContainTypeNavProps = {
  character: CharacterResult;
  lettersGetHandle: (letters: CharacterLetter[]) => void;
};

const WordExpressionContainTypeNav = ({
  character,
  lettersGetHandle,
}: WordExpressionContainTypeNavProps) => {
  const [navType, setNavType] = useState<string>(
    CHARACTER_RELATE_CONTAIN.CONTAIN
  );

  useEffect(() => {
    if (navType !== "") {
      if (navType === CHARACTER_RELATE_CONTAIN.CONTAIN) {
        const weContainTypeLetters = Array.from(character.letter).map(
          (letter: string) => {
            return {
              letter,
            };
          }
        );
        lettersGetHandle(weContainTypeLetters);
      }
    } else {
      lettersGetHandle([]);
    }
  }, [navType, character.letter]);

  const navTypeClickHandle = (navigationType: string) => {
    if (navigationType !== navType) {
      setNavType(navigationType);
    } else {
      setNavType("");
    }
  };

  return (
    <DivNavType>
      <RelateContainTypeNav
        active={navType === CHARACTER_RELATE_CONTAIN.CONTAIN}
        onClick={() => navTypeClickHandle(CHARACTER_RELATE_CONTAIN.CONTAIN)}
      >
        &or;
      </RelateContainTypeNav>
    </DivNavType>
  );
};

export default WordExpressionContainTypeNav;
